{
    "SCOPEASSIGNMENT_CME": "CME:",
    "SCOPEASSIGNMENT_FilterRecursively": "Filtrar recursivamente:",
    "SCOPEASSIGNMENT_TelServer": "Servidor de telefonia:",
    "SCOPEASSIGNMENT_Partition": "Partição:",
    "NAME": "ScopeAssignment"
}